// envUtils.ts
export const getEnvironment = () => import.meta.env.VITE_APP_ENV as string
